var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "second-customer-modal" }, [
    _c("div", { staticClass: "row mb-2" }, [
      _c(
        "div",
        {
          staticClass: "col d-flex justify-content-between align-items-center"
        },
        [
          _c("h4", {}, [
            _vm._v(
              _vm._s(_vm.customer.first_name) +
                " " +
                _vm._s(_vm.customer.last_name)
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-close p-0",
              on: {
                click: function($event) {
                  _vm.$emit("close")
                }
              }
            },
            [_c("span", { staticClass: "mod-icon-close opacity-50" })]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "plan-includes" }, [
      _c("div", { staticClass: "promo-features mt-3" }, [
        _c("div", { staticClass: "promo-feature" }, [
          _c("span", {
            staticClass: "mod-icon-edit mod-icon-phone",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.customer.phone
                  ? _vm.phoneMask.maskedPhone(_vm.customer.phone)
                  : "No phone added"
              ) +
              "\n      "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "promo-feature" }, [
          _c("span", {
            staticClass: "mod-icon-edit mod-icon-email",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v("\n        " + _vm._s(_vm.customer.email) + "\n      ")
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7605a980", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7605a980","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/modals/SecondCustomerInfo.vue
// module id = null
// module chunks = 